import { Component, Input } from '@angular/core'
import sweetAlert from 'src/bmAlert'
import { ISummaryData } from 'src/interfaces'
import { prettyCents, prettyDollars } from 'src/logic/pricing'
import { Coupon } from 'src/types'

@Component({
  selector: 'subscription-review',
  templateUrl: './subscription-review.component.html',
  styleUrls: ['./subscription-review.styles.scss']
})
export class SubscriptionReviewComponent {
  @Input() summaryData: ISummaryData
  @Input() withTitle = true

  currencyFormat(valueInCents: number): string {
    const cents = prettyCents(valueInCents)
    return '$' + prettyDollars(valueInCents) + (cents ? '.' + cents : '')
  }

  percentCouponDiscount(coupon: Coupon): number {
    let discountInCents = this.summaryData?.subTotalWithoutCouponsOrValet * coupon.discountPercent/100

    if (coupon.dollarLimit) {
      let discountLimitInCents = coupon.dollarLimit * 100
      discountInCents = discountInCents > discountLimitInCents ? discountLimitInCents : discountInCents
    }

    return discountInCents
  }
}
